/**
 * Notes what has focus and returns how to give it back. For a control disabled while its action runs: a dialog opened
 * meanwhile finds focus already lost, and the control only takes it again once the action has ended and it is enabled.
 * `within` is any element of the same root: `document` only sees the module's shadow root as one element.
 */
export const rememberFocus = (within: Node = document.body) => {
    const { activeElement } = within.getRootNode() as Document | ShadowRoot;

    return () => {
        requestAnimationFrame(() => {
            if (activeElement instanceof HTMLElement) {
                activeElement.focus();
            }
        });
    };
};
